import { useIsMobile } from '@cp/ds/src/hooks/useIsMobile';
import { Accordion } from '@cp/ds/src/components/accordion';
import { Grid } from '@cp/ds/src/components/grid';
import React from 'react';

export const FooterMenuSection: React.FC<{ summary: React.ReactNode; details: React.ReactNode; id: number }> = ({
  summary,
  details,
  id,
}) => {
  const isMobile = useIsMobile();
  return isMobile ? (
    <Grid size={{ md: 4, xs: 12 }}>
      <Accordion
        details={details}
        detailsId={`footer-menu-section-details-${id}`}
        detailsSx={{ px: 0 }}
        summary={summary}
        summaryId={`footer-menu-section-summary-${id}`}
        summarySx={{ px: 0 }}
      />
    </Grid>
  ) : (
    <Grid pb={6} size={{ lg: 3, md: 4, xl: 2.8 }}>
      {summary}
      {details}
    </Grid>
  );
};
